import { InputAdornment } from "@material-ui/core";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import {
  Button,
  CircularProgress,
  Grid,
  IconButton,
  Modal,
  TextField,
} from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { pdfjs } from "react-pdf";
import { useDispatch, useSelector } from "react-redux";
import "../../../Assets/css/kyc.css";
import Flag from "../../../Assets/img/Kyc/Flag1.jpg";
import Lion from "../../../Assets/img/Kyc/Lion.png";
import digi from "../../../Assets/img/Kyc/digi2.jpg";
import { ReactComponent as Cloud } from "../../../Assets/img/Kyc/svg/Cloud.svg";
import { ReactComponent as VerifiedTick } from "../../../Assets/img/icons/verified-tick.svg";
import {
  getKycOcrApiReducer,
  patchKycOcrReducer,
  postKycOcrApiReducer,
} from "../../../Redux/Reducers/KycReducer";
import { patchOnboardingReducer } from "../../../Redux/Reducers/OnboardingReducer";
import VerifyAadharSkeleton from "../../LoadingSkeleton/VerifyAadharSkeleton";
import VerifyAadharSkeleton2 from "../../LoadingSkeleton/VerifyAadharSkeleton2";
import { useQuantityContext } from "../../QuantityContext";
import { FreehandCropper } from "../../Utilities/Croppers";
import DigilockerButton from "./DigilockerButton";
import { MdDelete } from "react-icons/md";
pdfjs.GlobalWorkerOptions.workerSrc = `//unpkg.com/pdfjs-dist@${pdfjs.version}/build/pdf.worker.min.mjs`;


const VerifyAadhar = () => {
  const [isDragging, setIsDragging] = useState(false);
  const [previewData, setPreviewData] = useState({ front: null, back: null });
  const [isVerified, setIsVerified] = useState(false);
  const [isUploaded, setIsUploaded] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [apiResponse, setApiResponse] = useState({ front: null, back: null });
  const [selectedBgImage, setSelectedBgImage] = useState(null);
  const [selectedBgFile, setSelectedBgFile] = useState(null);
  const [openRectCropper, setOpenRectCropper] = useState(false);
  const [currentSide, setCurrentSide] = useState("");
  const [ocrResponse, setOcrResponse] = useState(null);
  const [isMaskedAadhaar, setIsMaskedAadhaar] = useState(false);
  const [isNewUpload, setIsNewUpload] = useState(false);

  const { openSnackbar, handleSuccess, handleFailure, handleInfo } =
    useQuantityContext();
  const [userData, setUserData] = useState({});
  const GetData = useSelector(
    (state) => state?.Kyc?.verifiedGetData?.data?.aadharData
  );
  const PanGetData = useSelector(
    (state) => state?.Kyc?.verifiedGetData?.data?.panData
  );
  const DlGetData = useSelector(
    (state) => state?.Kyc?.verifiedGetData?.data?.dlData
  );
  
  const [verifyStatus, setVerifiyStatus] = useState({
    aadhaar: false,
    pan: false,
    dl: false,
  });

  useEffect(() => {
    const isVerified = (value) =>
      value !== "Not verified Yet" && value !== undefined && value !== null;

    setVerifiyStatus({
      aadhaar: isVerified(GetData),
      pan: isVerified(PanGetData),
      dl: isVerified(DlGetData),
    });
  }, [GetData, PanGetData, DlGetData]);

  const [digilocker, setDigilocker] = useState({
    digilockerid: "",
    reference_key: "",
  });

//   console.log("digilocker", digilocker)

  const [finalVerifieddata, setFinalVerifieddata] = useState({});

  const [formData, setFormData] = useState({
    name: "",
    dob: "",
    fatherName: "",
    aadhaar: "",
    gender: "",
    houseNo: "",
    street: "",
    village: "",
    city: "",
    district: "",
    state: "",
    postalCode: "",
  });

  const dispatch = useDispatch();
  const [close, setClose] = useState(false);

  const handleKycCompletion = (data) => {
    setUserData(data);
    setIsVerified(true);
    // Save Digilocker data to localStorage
    localStorage.setItem('digilockerData', JSON.stringify(data));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Helper function to format gender
  const formatGender = (gender) => {
    if (!gender) return 'NA';
    if (gender === 'M') return 'Male';
    if (gender === 'F') return 'Female';
    if (gender === 'O') return 'Others';
    return gender;
  };

  // Fetch images and restore data
  const fetchImage = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/ocr/images`,
        {
          headers: {
            "x-api-key": process.env.REACT_APP_API_KEY,
            Authorization: `Bearer ${localStorage.getItem("objectId")}`,
          },
        }
      );
      
      const frontImg = response?.data?.data.filter(
        (img) => img.document_type === "Aadhaar_Front"
      )[0]?.blob_url;
      
      const backImg = response?.data?.data.filter(
        (img) => img.document_type === "Aadhaar_Back"
      )[0]?.blob_url;
      
      // Restore previews
      if (frontImg && backImg) {
        setPreviewData({ front: frontImg, back: backImg });
        setIsUploaded(true);
        
        // Restore OCR response from localStorage
        const savedOcrResponse = localStorage.getItem('aadharOcrResponse');
        if (savedOcrResponse) {
          try {
            const parsedOcr = JSON.parse(savedOcrResponse);
            setOcrResponse(parsedOcr);
            setIsNewUpload(true);
            
            // Check if masked
            const aadhaarNum = parsedOcr?.aadhaar_number || "";
            const masked = /[xX]/.test(aadhaarNum);
            setIsMaskedAadhaar(masked);
          } catch (e) {
            // console.error("Error parsing saved OCR response:", e);
            localStorage.removeItem('aadharOcrResponse');
          }
        }
        
        // Restore Digilocker data from localStorage
        const savedDigilockerData = localStorage.getItem('digilockerData');
        if (savedDigilockerData) {
          try {
            const parsedDigilocker = JSON.parse(savedDigilockerData);
            setUserData(parsedDigilocker);
            setIsVerified(true);
          } catch (e) {
            console.error("Error parsing saved Digilocker data:", e);
            localStorage.removeItem('digilockerData');
          }
        }
      }
    } catch (error) {
      console.error("Error fetching Aadhaar details:", error.message);
    }
  };

  useEffect(() => {
    fetchImage();
  }, []);

  useEffect(() => {
    const navurl = new URL(window.location.href);
    const code = navurl.searchParams.get("code");
    const state = navurl.searchParams.get("state");
    if (code && state) {
      setIsUploaded(true);
      setIsLoading(false);
      setOcrResponse({ ...ocrResponse, statusCode: 200 });
      setIsVerified(true);
    }
  }, []);

  const handleBlobUpload = async (base64Data, side) => {
    try {
      setApiResponse((prev) => {
        const updatedResponse = { ...prev, [side]: base64Data };
        return updatedResponse;
      });
    } catch (error) {
      console.error("Error uploading file:", error.message);
      handleFailure(error.message);
    }
  };

  const triggerOcr = async (apiResponse) => {
    try {
      setIsMaskedAadhaar(false);
      setOcrResponse(null);

      const viewerToken = localStorage.getItem("objectId")?.trim();
      const apiKey = process.env.REACT_APP_API_KEY;

      const headers = {
        "x-api-key": apiKey,
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${viewerToken}`,
      };

      const formData = new FormData();
      if (apiResponse.front) {
        try {
          const response = await fetch(apiResponse.front);
          const blob = await response.blob();
          formData.append("front_side", blob, "front_image.png");
        } catch (error) {
          console.error("Error converting blob to file:", error);
        }
      }

      if (apiResponse.back) {
        try {
          const response = await fetch(apiResponse.back);
          const blob = await response.blob();
          formData.append("back_side", blob, "back_image.png");
        } catch (error) {
          console.error("Error converting blob to file:", error);
        }
      }

      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/ocr/aadhaar`,
        formData,
        { headers }
      );
      // console.log("OCR Response:", response);

      const ocrData = response?.data?.data;
      setOcrResponse(ocrData);
      
      // Save OCR response to localStorage
      localStorage.setItem('aadharOcrResponse', JSON.stringify(ocrData));

      // Detect masked Aadhaar
      const aadhaarNum = ocrData?.aadhaar_number || "";
      const masked = /[xX]/.test(aadhaarNum);
      setIsMaskedAadhaar(masked);
      setIsUploaded(true);
      setIsLoading(false);
      setIsNewUpload(true);
      handleSuccess("Upload successful!");
    } catch (error) {
      console.error(
        "Error during OCR API call:",
        error.response?.data || error.message
      );
      handleFailure(error.response?.data?.message);
    }
  };

  // Update form data when GetData (verified data) or OCR response changes
  useEffect(() => {
    if (GetData && Object.keys(GetData).length > 0 && GetData !== "Not verified Yet") {
      // Use verified GetData first
      setFormData({
        name: GetData?.name || "",
        dob: GetData?.dob || "",
        fatherName: GetData?.co || "",
        aadhaar: GetData?.aadhaar_number || "",
        gender: GetData?.gender === "M" ? "Male" : GetData?.gender === "F" ? "Female" : GetData?.gender === "O" ? "Others" : "",
        houseNo: GetData?.house || "",
        street: GetData?.street || "",
        village: GetData?.locality || GetData?.vtc || "",
        city: GetData?.city || "",
        district: GetData?.district || "",
        state: GetData?.state || "",
        postalCode: GetData?.postal_code || "",
      });
    } else if (isNewUpload && ocrResponse) {
      // Use OCR response for unverified data
      setFormData({
        name: ocrResponse?.name || "",
        dob: ocrResponse?.dob || "",
        fatherName: ocrResponse?.father_name || "",
        aadhaar: ocrResponse?.aadhaar_number || "",
        gender: ocrResponse?.gender === "M" ? "Male" : ocrResponse?.gender === "F" ? "Female" : ocrResponse?.gender === "O" ? "Others" : "",
        houseNo: ocrResponse?.house || "",
        street: ocrResponse?.street || "",
        village: ocrResponse?.locality || "",
        city: ocrResponse?.city || "",
        district: ocrResponse?.district || "",
        state: ocrResponse?.state || "",
        postalCode: ocrResponse?.postal_code || "",
      });
    }
  }, [ocrResponse, GetData, isNewUpload]);

  useEffect(() => {
    if (finalVerifieddata && Object.keys(finalVerifieddata).length > 0) {
      setFormData({
        name: finalVerifieddata?.name || "",
        dob: finalVerifieddata?.dob || "",
        fatherName: finalVerifieddata?.co || "",
        aadhaar: finalVerifieddata?.aadhaar_number || "",
        gender: finalVerifieddata?.gender === "M" ? "Male" : finalVerifieddata?.gender === "F" ? "Female" : finalVerifieddata?.gender === "O" ? "Others" : "",
        houseNo: finalVerifieddata?.house || "",
        street: finalVerifieddata?.street || "",
        village: finalVerifieddata?.vtc || finalVerifieddata?.locality || "",
        city: finalVerifieddata?.city || "",
        district: finalVerifieddata?.district || "",
        state: finalVerifieddata?.state || "",
        postalCode: finalVerifieddata?.postal_code || "",
      });
    }
  }, [finalVerifieddata]);

  const handleUpload = async () => {
    if (!previewData.front || !previewData.back) {
      handleFailure(
        "Both front and back images must be uploaded before proceeding."
      );
      return;
    }

    setIsLoading(true);
    setIsNewUpload(false);

    try {
      const uploadPayload = {
        front: previewData.front,
        back: previewData.back,
      };
      setApiResponse(uploadPayload);
      await triggerOcr(uploadPayload);
    } catch (error) {
      setIsLoading(false);
      console.error("Error during upload:", error);
    }
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = () => setIsDragging(false);

  const handleFileDrop = (e, side) => {
    e.preventDefault();
    setIsDragging(false);
    const file = e.dataTransfer.files[0];
    handleFileChange(file, side);
  };

  const handleFileChange = (file, side) => {
    if (!file) return;

    if (file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = (event) => {
        setSelectedBgImage(event.target.result);
        setSelectedBgFile(file);
        setCurrentSide(side);
        setOpenRectCropper(true);
      };
      reader.readAsDataURL(file);
    } else if (file.type === "application/pdf") {
      const reader = new FileReader();
      reader.onloadend = () => renderPdfToImage(reader.result, side);
      reader.readAsArrayBuffer(file);
    } else {
      console.error("Unsupported file type");
    }
  };

  const handleSaveBgImage = async (croppedFile, side) => {
    const file = URL.createObjectURL(croppedFile);
    setPreviewData((prev) => ({ ...prev, [side]: file }));
    setIsNewUpload(false);
    setOcrResponse(null);
    // Clear OCR data when image is replaced
    localStorage.removeItem('aadharOcrResponse');
    handleRectCropperClose();
  };

  const renderPdfToImage = (pdfData, side) => {
    pdfjs.getDocument({ data: pdfData }).promise.then((pdf) => {
      pdf.getPage(1).then((page) => {
        const viewport = page.getViewport({ scale: 1 });
        const canvas = document.createElement("canvas");
        const canvasContext = canvas.getContext("2d");
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        page.render({ canvasContext, viewport }).promise.then(() => {
          const resizedImageBase64 = resizeCanvasToWidth(canvas, 512);
          setSelectedBgImage(resizedImageBase64);
          setSelectedBgFile(pdfData);
          setCurrentSide(side);
          setOpenRectCropper(true);
        });
      });
    });
  };

  const resizeCanvasToWidth = (canvas, targetWidth) => {
    const targetHeight = (targetWidth / canvas.width) * canvas.height;
    const resizedCanvas = document.createElement("canvas");
    const resizedContext = resizedCanvas.getContext("2d");

    resizedCanvas.width = targetWidth;
    resizedCanvas.height = targetHeight;

    resizedContext.drawImage(canvas, 0, 0, targetWidth, targetHeight);

    return resizedCanvas.toDataURL("image/jpeg");
  };

  const handleRectCropperClose = () => {
    setOpenRectCropper(false);
    setSelectedBgFile(null);
    setSelectedBgImage(null);
  };

  const handleupdate = async () => {
    try {
      // console.log("FormData", formData);
      const dateStr = formData?.dob;
      const year = dateStr?.split("-")[2] || "";

      const data = {
        name: formData?.name,
        father_name: formData?.fatherName,
        dob: formData?.dob,
        yob: year,
        co: formData?.fatherName,
        district: formData?.district,
        house: formData?.houseNo,
        locality: formData?.village,
        city: formData?.city,
        state: formData?.state,
        postal_code: formData?.postalCode,
        street: formData?.street,
      };

      const response = await dispatch(patchKycOcrReducer(data));

      // console.log("Response Data", response);
      if (response?.payload?.statusCode === 201) {
        // Clear OCR data from localStorage after verification
        localStorage.removeItem('aadharOcrResponse');
        
        setClose(false);
        const data = {
          aadharVerified: true,
          panVerified: verifyStatus?.pan,
          dlVerified: verifyStatus?.dl,
          digilockerid: digilocker?.digilockerid,
          reference_key: digilocker?.reference_key,
        };

        const Postresponse = await dispatch(postKycOcrApiReducer(data));
        // console.log("postKycOcrApiReducer", Postresponse);

        if (
          Postresponse?.payload?.message?.message ===
          "DigilockerID & ReferrenceKey is necessary for the verification"
        ) {
          handleInfo("DigiLocker verification is required to proceed.");
        }
        const kycresponse = await dispatch(getKycOcrApiReducer());
        // console.log("getKycOcrApiReducer", kycresponse);

        if (kycresponse?.payload?.statusCode === 200) {
          const aadharData = kycresponse?.payload?.data?.aadharData;
          setFinalVerifieddata(aadharData);

          // Update userData with the verified data
          if (aadharData && Object.keys(aadharData).length > 0) {
            setUserData(aadharData);
            // Save to localStorage
            localStorage.setItem('digilockerData', JSON.stringify(aadharData));
          }

          const fullName = aadharData?.name || "";
          const nameParts = fullName.trim().split(" ");

          const payload = {
            first_name: nameParts.slice(0, -1).join(" "),
            last_name: nameParts.slice(-1)[0] || "",
            dob: aadharData?.dob || null,
            gender: aadharData?.gender === "F" ? "female" : aadharData?.gender === "M" ? "male" : null,
            address: `${aadharData?.postal_code || ""} ${aadharData?.locality || ""} ${aadharData?.vtc || ""} ${aadharData?.street || ""} ${aadharData?.city || ""} ${aadharData?.district || ""} ${aadharData?.state || ""}`.trim(),
          };
          // console.log("Payload", payload);

          const patchResponse = await dispatch(patchOnboardingReducer(payload));
          // console.log("patchResponse", patchResponse);
        }
      }
    } catch (error) {
      console.log("API ERROR", error);
    }
  };

  const handleVerify = () => setIsVerified(true);

  // OCR fields for unverified data
  const ocrFields = isNewUpload ? [
    { label: "Aadhaar Number", value: ocrResponse?.aadhaar_number || "NA" },
    { label: "Name", value: ocrResponse?.name || "NA" },
    { label: "Father's Name", value: ocrResponse?.father_name || "NA" },
    ...(ocrResponse?.dob
      ? [{ label: "Date of Birth", value: ocrResponse?.dob }]
      : ocrResponse?.year_of_birth
        ? [{ label: "Year of Birth", value: ocrResponse?.year_of_birth }]
        : [{ label: "Date of Birth/Year", value: "NA" }]),
    {
      label: "Gender",
      value: formatGender(ocrResponse?.gender),
    },
    { label: "Street", value: ocrResponse?.street || "NA" },
    { label: "Locality", value: ocrResponse?.locality || "NA" },
    { label: "City", value: ocrResponse?.city || "NA" },
    { label: "District", value: ocrResponse?.district || "NA" },
    { label: "State", value: ocrResponse?.state || "NA" },
    { label: "Postal Code", value: ocrResponse?.postal_code || "NA" },
    { label: "Country", value: ocrResponse?.country || "India" },
    { label: "House", value: ocrResponse?.house || "NA" },
  ] : [];

  // Verified fields from GetData
  const VerifiedFields = [
    { label: "Aadhaar Number", value: GetData?.aadhaar_number || "NA" },
    { label: "Name", value: GetData?.name || "NA" },
    { label: "Father's Name", value: GetData?.co || "NA" },
    ...(GetData?.dob
      ? [{ label: "Date of Birth", value: GetData?.dob }]
      : GetData?.year_of_birth
        ? [{ label: "Year of Birth", value: GetData?.year_of_birth }]
        : [{ label: "Date of Birth/Year", value: "NA" }]),
    {
      label: "Gender",
      value: formatGender(GetData?.gender),
    },
    { label: "Street", value: GetData?.street || "NA" },
    { label: "Locality/Village", value: GetData?.locality || GetData?.vtc || "NA" },
    { label: "City", value: GetData?.city || "NA" },
    { label: "District", value: GetData?.district || "NA" },
    { label: "State", value: GetData?.state || "NA" },
    { label: "Postal Code", value: GetData?.postal_code || "NA" },
    { label: "Country", value: GetData?.country || "India" },
    { label: "House", value: GetData?.house || "NA" },
  ];

  // Digilocker data from GetData (verified) or userData
  const Digilockerdata = {
    name: GetData?.name || userData?.name || "",
    dob: GetData?.dob || userData?.dob || "",
    fatherName: GetData?.co || userData?.co || "",
    gender: formatGender(GetData?.gender || userData?.gender),
    houseno: GetData?.house || userData?.house || "",
    street: GetData?.street || userData?.street || "",
    village: GetData?.locality || GetData?.vtc || userData?.locality || "",
    city: GetData?.city || userData?.city || "",
    district: GetData?.district || userData?.district || "",
    State: GetData?.state || userData?.state || "",
    postalCode: GetData?.postal_code || userData?.postal_code || "",
    masked_id: GetData?.masked_id || userData?.masked_id || "",
    // photo: GetData?.photo || userData?.photo || "",
    aadhaar_number: GetData?.aadhaar_number || userData?.aadhaar_number || "",
    country: GetData?.country || userData?.country || "India"
  };
  // console.log("Digilockerdata", Digilockerdata)
  // Helper function to check if any field has data
  const hasAnyData = () => {
    return (
      GetData?.name || ocrResponse?.name || Digilockerdata?.name ||
      GetData?.aadhaar_number || ocrResponse?.aadhaar_number || Digilockerdata?.aadhaar_number ||
      GetData?.dob || ocrResponse?.dob || Digilockerdata?.dob ||
      GetData?.co || ocrResponse?.father_name || Digilockerdata?.fatherName ||
      GetData?.gender || ocrResponse?.gender || Digilockerdata?.gender ||
      GetData?.house || ocrResponse?.house || Digilockerdata?.houseno ||
      GetData?.street || ocrResponse?.street || Digilockerdata?.street ||
      GetData?.locality || GetData?.vtc || ocrResponse?.locality || Digilockerdata?.village ||
      GetData?.city || ocrResponse?.city || Digilockerdata?.city ||
      GetData?.district || ocrResponse?.district || Digilockerdata?.district ||
      GetData?.state || ocrResponse?.state || Digilockerdata?.State ||
      GetData?.postal_code || ocrResponse?.postal_code || Digilockerdata?.postalCode
    );
  };

  // Helper function to get mismatch count for correction modal
  const getMismatchCount = () => {
    let count = 0;

    // Compare with GetData if available (verified data), otherwise with Digilockerdata
    const compareData = GetData && Object.keys(GetData).length > 0 && GetData !== "Not verified Yet" ? {
      dob: GetData?.dob,
      fatherName: GetData?.co,
      gender: formatGender(GetData?.gender),
      houseno: GetData?.house,
      street: GetData?.street,
      village: GetData?.locality || GetData?.vtc,
      city: GetData?.city,
      district: GetData?.district,
      State: GetData?.state,
      postalCode: GetData?.postal_code
    } : Digilockerdata;

    if (compareData?.dob && formData.dob && formData.dob !== compareData.dob) count++;
    if (compareData?.fatherName && formData.fatherName && formData.fatherName !== compareData.fatherName) count++;
    if (compareData?.gender && formData.gender && formData.gender !== compareData.gender) count++;
    if (compareData?.houseno && formData.houseNo && formData.houseNo !== compareData.houseno) count++;
    if (compareData?.street && formData.street && formData.street !== compareData.street) count++;
    if (compareData?.village && formData.village && formData.village !== compareData.village) count++;
    if (compareData?.city && formData.city && formData.city !== compareData.city) count++;
    if (compareData?.district && formData.district && formData.district !== compareData.district) count++;
    if (compareData?.State && formData.state && formData.state !== compareData.State) count++;
    if (compareData?.postalCode && formData.postalCode && formData.postalCode !== compareData.postalCode) count++;

    return count;
  };

  const handleupdateverifyModal = () => {
    if (Digilockerdata?.name) {
      setClose(true);
    }
  };

  const uploadZoneStyle = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "16px",
    border: "2px dashed #CBD5E1",
    borderRadius: "8px",
    cursor: "pointer",
    minHeight: "140px",
    width: "100%",
    boxSizing: "border-box",
  };

  return (
    <div className="Main-Container-kyc">
      <div className="rounded-2 bg-white p-2">
        <div className="d-flex flex-column text-center m-4">
          <h2 className="m-0 fw-bold">Verify Your Aadhaar details</h2>
          <p className="paragraph m-0">
            Upload Your Aadhaar Card for Secure Verification.
          </p>

          <div className="d-flex flex-row justify-content-evenly mt-4">
            {/* Left: Image Previews */}
            <div
              className="imagePreviewContainer"
              style={{ marginTop: "10px" }}
            >
              {!previewData?.front && !previewData?.back ? (
                <VerifyAadharSkeleton />
              ) : (
                <>
                  {previewData?.front && (
                    <div
                      style={{
                        position: 'relative',
                        display: 'inline-block',
                        marginBottom: '10px'
                      }}
                      onMouseEnter={(e) => {
                        const overlay = e.currentTarget.querySelector('.delete-overlay-front');
                        if (overlay) overlay.style.opacity = '1';
                      }}
                      onMouseLeave={(e) => {
                        const overlay = e.currentTarget.querySelector('.delete-overlay-front');
                        if (overlay) overlay.style.opacity = '0';
                      }}
                    >
                      <img
                        src={previewData?.front}
                        alt="Front Preview"
                        style={{
                          maxWidth: "300px",
                          boxShadow: "rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px",
                          border: "1px dashed gray",
                          padding: "3px",
                          display: 'block'
                        }}
                      />
                      <div
                        className="delete-overlay-front"
                        onClick={!verifyStatus?.aadhaar ? () => {
                          setPreviewData(prev => ({ ...prev, front: null }));
                          setApiResponse(prev => ({ ...prev, front: null }));
                          setIsMaskedAadhaar(false);
                          setOcrResponse(null);
                          setIsNewUpload(false);
                          localStorage.removeItem('aadharOcrResponse');
                        } : undefined}
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          backgroundColor: 'rgba(0, 0, 0, 0.5)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          opacity: 0,
                          transition: 'opacity 0.2s ease-in-out',
                          cursor: verifyStatus?.aadhaar ? 'not-allowed' : 'pointer',
                          zIndex: 10
                        }}
                      >
                        {!verifyStatus?.aadhaar ? <MdDelete style={{ fontSize: '48px', color: '#ff0000' }} /> : ""}
                      </div>
                    </div>
                  )}

                  {previewData?.back && (
                    <div
                      style={{
                        position: 'relative',
                        display: 'inline-block',
                        marginBottom: '10px'
                      }}
                      onMouseEnter={(e) => {
                        const overlay = e.currentTarget.querySelector('.delete-overlay-back');
                        if (overlay) overlay.style.opacity = '1';
                      }}
                      onMouseLeave={(e) => {
                        const overlay = e.currentTarget.querySelector('.delete-overlay-back');
                        if (overlay) overlay.style.opacity = '0';
                      }}
                    >
                      <img
                        src={previewData?.back}
                        alt="Back Preview"
                        style={{
                          maxWidth: "300px",
                          boxShadow: "rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px",
                          border: "1px dashed gray",
                          padding: "3px",
                          display: 'block'
                        }}
                      />
                      <div
                        className="delete-overlay-back"
                        onClick={!verifyStatus?.aadhaar ? () => {
                          setPreviewData(prev => ({ ...prev, back: null }));
                          setApiResponse(prev => ({ ...prev, back: null }));
                          setIsMaskedAadhaar(false);
                          setOcrResponse(null);
                          setIsNewUpload(false);
                          localStorage.removeItem('aadharOcrResponse');
                        } : undefined}
                        style={{
                          position: 'absolute',
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          backgroundColor: 'rgba(0, 0, 0, 0.5)',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          opacity: 0,
                          transition: 'opacity 0.2s ease-in-out',
                          cursor: verifyStatus?.aadhaar ? 'not-allowed' : 'pointer',
                          zIndex: 10
                        }}
                      >
                        {!verifyStatus?.aadhaar ? <MdDelete style={{ fontSize: '48px', color: '#ff0000' }} /> : ""}
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>

            {/* Centre: Upload Zones + Tables */}
            <div className="uploadContainer">
              {(GetData === "Not verified Yet" ||
                GetData === null ||
                !GetData ||
                Object.keys(GetData).length === 0) && (
                  <div className="uploadContainer-card">
                    {/* Front Upload Zone */}
                    <div
                      onDragOver={handleDragOver}
                      onDragLeave={handleDragLeave}
                      onDrop={(e) => handleFileDrop(e, "front")}
                      className="uploadZone"
                    >
                      <input
                        type="file"
                        accept="image/*, application/pdf"
                        style={{ display: "none" }}
                        onChange={(e) => {
                          const file = e.target.files[0];
                          const maxSize = 5 * 1024 * 1024;
                          if (file && file.size > maxSize) {
                            handleInfo("File size exceeds 5MB limit. Please choose a smaller file.");
                            e.target.value = '';
                            return;
                          }
                          handleFileChange(file, "front");
                        }}
                        id="file-input-front"
                      />
                      <label
                        htmlFor="file-input-front"
                        className="uploadLabel"
                        style={uploadZoneStyle}
                      >
                        <Cloud width={80} />
                        <span className="m-0 p-0">
                          {isDragging
                            ? "Drop front file here"
                            : "Drag front card here or"}
                          <span className="text-primary"> Upload File</span>
                        </span>
                        <p style={{ margin: 0 }}>5MB max file size</p>
                      </label>
                    </div>

                    {/* Back Upload Zone */}
                    <div
                      onDragOver={handleDragOver}
                      onDragLeave={handleDragLeave}
                      onDrop={(e) => handleFileDrop(e, "back")}
                      className="uploadZone"
                    >
                      <input
                        type="file"
                        accept="image/*, application/pdf"
                        style={{ display: "none" }}
                        onChange={(e) => {
                          const file = e.target.files[0];
                          const maxSize = 5 * 1024 * 1024;
                          if (file && file.size > maxSize) {
                            handleInfo("File size exceeds 5MB limit. Please choose a smaller file.");
                            e.target.value = '';
                            return;
                          }
                          handleFileChange(file, "back");
                        }}
                        id="file-input-back"
                      />
                      <label
                        htmlFor="file-input-back"
                        className="uploadLabel"
                        style={uploadZoneStyle}
                      >
                        <Cloud width={80} />
                        <span className="m-0 p-0">
                          {isDragging
                            ? "Drop back file here"
                            : "Drag back card here or"}
                          <span className="text-primary"> Upload File</span>
                        </span>
                        <p style={{ margin: 0 }}>5MB max file size</p>
                      </label>
                    </div>
                  </div>
                )}

              <div
                style={{ display: "flex", flexDirection: "column", gap: "5px" }}
              >
                {(GetData === "Not verified Yet" ||
                  GetData === null ||
                  !GetData ||
                  Object.keys(GetData).length === 0) &&
                  (isLoading ? (
                    <CircularProgress size={40} />
                  ) : (
                    <Button
                      variant="contained"
                      className="btncolor"
                      onClick={handleUpload}
                    >
                      Upload
                    </Button>
                  ))}

                {/* Masked Aadhaar warning */}
                {isMaskedAadhaar && (
                  <div
                    style={{
                      backgroundColor: "#FFF3CD",
                      border: "1px solid #FFC107",
                      borderRadius: "8px",
                      padding: "12px 16px",
                      marginTop: "8px",
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "10px",
                    }}
                  >
                    <span style={{ fontSize: "20px", lineHeight: 1 }}>⚠️</span>
                    <div>
                      <p
                        style={{
                          margin: 0,
                          fontSize: "14px",
                          fontWeight: "600",
                          color: "#856404",
                        }}
                      >
                        Masked Aadhaar Detected
                      </p>
                      <p
                        style={{
                          margin: "4px 0 0",
                          fontSize: "13px",
                          color: "#856404",
                        }}
                      >
                        Please upload the original (non-masked) Aadhaar to verify your identity.
                      </p>
                    </div>
                  </div>
                )}

                {/* DigilockerButton - only show when not verified */}
                {isNewUpload &&
                  ocrResponse &&
                  !isMaskedAadhaar &&
                  (GetData === "Not verified Yet" ||
                    GetData === null ||
                    !GetData ||
                    Object.keys(GetData).length === 0) && (
                    <DigilockerButton
                      doc={"aadhaar"}
                      onKycComplete={handleKycCompletion}
                      setDigilocker={setDigilocker}
                    />
                  )}

                {GetData && Object.keys(GetData).length > 0 && GetData !== "Not verified Yet" && (
                  <h3 className="fw-semibold">KYC Verification Completed</h3>
                )}
              </div>

              {!verifyStatus?.aadhaar && (
                <div style={{ marginTop: "20px" }}>
                  {isNewUpload && ocrResponse && (
                    <p
                      className="text-xs text-amber-600 mt-2 text-center"
                      style={{ fontSize: "14px", color: "#ff9800", textAlign: "center" }}
                    >
                      {!Digilockerdata?.name
                        ? 'Aadhaar Card uploaded. Click "Verify with Digilocker" to complete verification.'
                        : 'Click on Verify icon to make the corrections and save'
                      }
                    </p>
                  )}
                </div>
              )}

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-evenly",
                  gap: "6px",
                  padding: "15px",
                  borderRadius: "8px",
                }}
              >
                <div
                  style={{
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  {/* Show Verified Data from GetData */}
                  {GetData && Object.keys(GetData).length > 0 && GetData !== "Not verified Yet" ? (
                    <div
                      className="rounded"
                      style={{
                        width: "100%",
                        padding: "10px",
                        border: "1px solid gray",
                      }}
                    >
                      <div className="d-flex flex-row justify-content-between align-items-center">
                        <h5 className="fw-semibold">Verified Aadhaar Data</h5>
                        <div className="flex-center mb-1">
                          <VerifiedTick className="green-verified-tick" />
                        </div>
                      </div>

                      <div
                        style={{
                          maxHeight: "450px",
                          overflowY: "auto",
                          scrollbarWidth: "none",
                        }}
                      >
                        <table className="mytable mb-1">
                          <tbody>
                            <tr>
                              <th className="mytable">Field</th>
                              <th className="mytable">Data</th>
                            </tr>
                            {VerifiedFields?.map((field, index) => (
                              <tr key={index}>
                                <td className="mytable"> {field.label}</td>
                                <td
                                  className="mytable"
                                  style={{ borderWidth: "1" }}
                                >
                                  {field.value || "NA"}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  ) : (
                    // Show OCR Data when not verified
                    isNewUpload && ocrResponse && ocrFields.some(f => f.value && f.value !== "NA") ? (
                      <div
                        className="rounded"
                        style={{
                          width: "100%",
                          padding: "10px",
                          border: "1px solid gray",
                        }}
                      >
                        <div className="d-flex flex-row justify-content-between align-items-center">
                          <h5 className="fw-semibold">Data from OCR</h5>
                          <div
                            className="flex-center mb-1"
                            onClick={() => handleupdateverifyModal()}
                          >
                            <IconButton>
                              <VerifiedTick />
                            </IconButton>
                            <div>Verify</div>
                          </div>
                        </div>

                        <div
                          style={{
                            maxHeight: "450px",
                            overflowY: "auto",
                            scrollbarWidth: "none",
                          }}
                        >
                          <table className="mytable mb-1">
                            <tbody>
                              <tr>
                                <th className="mytable">Field</th>
                                <th className="mytable">Data</th>
                              </tr>
                              {ocrFields?.map((field, index) => (
                                <tr key={index}>
                                  <td className="mytable"> {field.label}</td>
                                  <td
                                    className="mytable"
                                    style={{ borderWidth: "1" }}
                                  >
                                    {field.value || "NA"}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    ) : null
                  )}
                </div>

                {/* Show Digilocker Data when verified */}
                {/* {GetData && Object.keys(GetData).length > 0 && GetData !== "Not verified Yet" ? ( */}
                {userData?.masked_id  && ocrResponse  ? (
                  <div
                    className="rounded"
                    style={{
                      width: "100%",
                      padding: "10px",
                      border: "1px solid gray",
                    }}
                  >
                    <h5 className="fw-semibold">Digilocker Verified Data</h5>
                    <div
                      style={{
                        maxHeight: "450px",
                        overflowY: "auto",
                        scrollbarWidth: "none",
                      }}
                    >
                      <table className="mytable">
                        <tbody>
                          <tr>
                            <th className="mytable">Field</th>
                            <th className="mytable">Data</th>
                          </tr>
                          {Object.keys(Digilockerdata).map(
                            (field, index) => (
                              <tr key={index}>
                                <td className="mytable">
                                  {field.charAt(0).toUpperCase() +
                                    field.slice(1).replace(/([A-Z])/g, ' $1').trim()}
                                </td>
                                <td
                                  className="mytable"
                                  style={{ borderWidth: "1" }}
                                >
                                  {Digilockerdata[field] || "NA"}
                                </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>

            {/* Right: Aadhaar Card Preview */}
            <div className="imagePreviewContainer2">
              {GetData && Object.keys(GetData).length > 0 && GetData !== "Not verified Yet" ? (
                <div
                  style={{
                    border: "2px solid gray",
                    borderRadius: "15px",
                    padding: "10px",
                    boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.2)",
                    maxWidth: "100%",
                    margin: "auto",
                    width: "350px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-evenly",
                      flexWrap: "wrap",
                      rowGap: "10px",
                    }}
                  >
                    <img
                      style={{ width: "15%", minWidth: "80px", objectFit: "contain" }}
                      src={Lion}
                      alt="logo"
                    />
                    <img
                      style={{ width: "20%", minWidth: "100px", objectFit: "contain" }}
                      src={Flag}
                      alt="logo"
                    />
                    <img
                      style={{ width: "20%", minWidth: "80px", objectFit: "contain" }}
                      src={"https://www.pngkey.com/png/full/224-2240746_aadhaar-logo-aadhar-card-logo-png.png"}
                      alt="logo"
                    />
                  </div>

                  <div
                    style={{
                      display: "flex",
                      padding: "5px",
                      flexDirection: "row",
                      gap: "20px",
                      alignItems: "center",
                      marginTop: "15px",
                      flexWrap: "nowrap",
                      width: "100%",
                      maxWidth: "600px",
                    }}
                  >
                    <img
                      style={{ width: "30%", minWidth: "120px" }}
                      src={
                        GetData?.photo
                          ? `data:image/png;base64,${GetData?.photo}`
                          : "https://icon-library.com/images/man-png-icon/man-png-icon-14.jpg"
                      }
                      alt="profile"
                    />
                    <div
                      style={{
                        textAlign: "left",
                        flex: "1",
                        display: "flex",
                        flexDirection: "column",
                        minWidth: "200px",
                      }}
                    >
                      <h6>Name: {GetData?.name || "N/A"}</h6>
                      <h6>DOB: {GetData?.dob || "N/A"}</h6>
                      <h6>Gender: {formatGender(GetData?.gender) || "N/A"}</h6>
                      <h6>Aadhaar: {GetData?.masked_id || GetData?.aadhaar_number || "N/A"}</h6>
                    </div>
                  </div>

                  <hr />

                  <div style={{ textAlign: "left", padding: "10px" }}>
                    <h6>
                      Address: {GetData?.house || ""} {GetData?.street || ""}{" "}
                      {GetData?.locality || GetData?.vtc || ""} {GetData?.city || ""} {GetData?.district || ""} {GetData?.state || ""}
                    </h6>
                  </div>

                  <hr />

                  <div
                    style={{
                      textAlign: "left",
                      padding: "20px",
                      display: "flex",
                      justifyContent: "space-evenly",
                      flexWrap: "wrap",
                      rowGap: "15px",
                    }}
                  >
                    <img
                      style={{
                        width: "60%",
                        minWidth: "100px",
                        height: "auto",
                        objectFit: "contain",
                      }}
                      src={digi}
                      alt="digi locker logo"
                    />
                  </div>

                  <hr
                    style={{
                      color: "red",
                      width: "80%",
                      margin: "auto",
                      padding: "5px",
                    }}
                  />
                  <h6>
                    <span style={{ color: "red" }}>आधार</span> -आम आदमी का
                    अधिकार
                  </h6>
                </div>
              ) : (
                <VerifyAadharSkeleton2 />
              )}
              <FreehandCropper
                open={openRectCropper}
                onClose={handleRectCropperClose}
                onSave={(croppedFile) =>
                  handleSaveBgImage(croppedFile, currentSide)
                }
                file={selectedBgFile}
                selectedImage={selectedBgImage}
              />
            </div>

            {/* Correction Modal */}
            <Modal open={close}>
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  backgroundColor: "white",
                  padding: "24px",
                  width: "800px",
                  maxHeight: "80vh",
                  overflowY: "auto",
                  borderRadius: "8px",
                  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                }}
              >
                {/* Header with Close Button */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "24px",
                  }}
                >
                  <div>
                    <h5
                      style={{
                        fontSize: "20px",
                        fontWeight: "600",
                        color: "#111827",
                        margin: "0 0 4px 0",
                      }}
                    >
                      Correct Aadhaar Details
                    </h5>
                    <p
                      style={{
                        fontSize: "14px",
                        color: "#6B7280",
                        margin: "0",
                      }}
                    >
                      {getMismatchCount()} field(s) need correction to match verified data
                      <span
                        style={{
                          marginLeft: "8px",
                          fontSize: "12px",
                          color: "#DC2626",
                          fontWeight: "500",
                        }}
                      >
                        (Name and Aadhaar Number cannot be edited)
                      </span>
                    </p>
                  </div>
                  <IconButton
                    onClick={() => setClose(false)}
                    size="small"
                    style={{ color: "#6B7280" }}
                  >
                    <CloseRoundedIcon />
                  </IconButton>
                </div>

                {/* Fields Container */}
                <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                  {/* Name Field */}
                  {(ocrResponse?.name || GetData?.name || Digilockerdata?.name) && (
                    <div
                      style={{
                        border: "1px solid #E5E7EB",
                        borderRadius: "8px",
                        padding: "16px",
                      }}
                    >
                      <div>
                        <label
                          style={{
                            fontSize: "14px",
                            fontWeight: "500",
                            color: "#374151",
                            marginBottom: "8px",
                            display: "block",
                          }}
                        >
                          Name
                        </label>

                        {(ocrResponse?.name || GetData?.name) && (
                          <>
                            <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "4px" }}>
                              Current (from OCR):
                            </div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                padding: "8px 12px",
                                backgroundColor: "#F9FAFB",
                                border: "1px solid #E5E7EB",
                                borderRadius: "6px",
                                marginBottom: "12px",
                              }}
                            >
                              <span style={{ color: "#374151", fontSize: "14px" }}>
                                {ocrResponse?.name || GetData?.name}
                              </span>
                            </div>
                          </>
                        )}

                        {Digilockerdata?.name && (
                          <>
                            <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "4px" }}>
                              Verified Data:
                            </div>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                padding: "8px 12px",
                                backgroundColor: "#F0FDF4",
                                border: "1px solid #86EFAC",
                                borderRadius: "6px",
                              }}
                            >
                              <span style={{ color: "#15803D", fontSize: "14px", fontWeight: "500" }}>
                                {Digilockerdata.name}
                              </span>
                              {(ocrResponse?.name === Digilockerdata.name ||
                                GetData?.name === Digilockerdata.name) && (
                                  <span
                                    style={{
                                      marginLeft: "8px",
                                      padding: "2px 8px",
                                      backgroundColor: "#86EFAC",
                                      color: "#166534",
                                      fontSize: "11px",
                                      fontWeight: "600",
                                      borderRadius: "12px",
                                      display: "inline-flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    ✓ Verified
                                  </span>
                                )}
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Aadhaar Number Field */}
                  {(ocrResponse?.aadhaar_number ||
                    GetData?.aadhaar_number ||
                    Digilockerdata?.aadhaar_number) && (
                      <div
                        style={{
                          border: "1px solid #E5E7EB",
                          borderRadius: "8px",
                          padding: "16px",
                        }}
                      >
                        <div>
                          <label
                            style={{
                              fontSize: "14px",
                              fontWeight: "500",
                              color: "#374151",
                              marginBottom: "8px",
                              display: "block",
                            }}
                          >
                            Aadhaar Number
                          </label>

                          {(ocrResponse?.aadhaar_number || GetData?.aadhaar_number) && (
                            <>
                              <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "4px" }}>
                                Current (from OCR):
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  padding: "8px 12px",
                                  backgroundColor: "#F9FAFB",
                                  border: "1px solid #E5E7EB",
                                  borderRadius: "6px",
                                  marginBottom: "12px",
                                }}
                              >
                                <span style={{ color: "#374151", fontSize: "14px" }}>
                                  {ocrResponse?.aadhaar_number || GetData?.aadhaar_number}
                                </span>
                              </div>
                            </>
                          )}

                          {Digilockerdata?.aadhaar_number && (
                            <>
                              <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "4px" }}>
                                Verified Data:
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "space-between",
                                  padding: "8px 12px",
                                  backgroundColor: "#F0FDF4",
                                  border: "1px solid #86EFAC",
                                  borderRadius: "6px",
                                }}
                              >
                                <span style={{ color: "#15803D", fontSize: "14px", fontWeight: "500" }}>
                                  {Digilockerdata.aadhaar_number}
                                </span>
                                {(ocrResponse?.aadhaar_number === Digilockerdata.aadhaar_number ||
                                  GetData?.aadhaar_number === Digilockerdata.aadhaar_number) && (
                                    <span
                                      style={{
                                        marginLeft: "8px",
                                        padding: "2px 8px",
                                        backgroundColor: "#86EFAC",
                                        color: "#166534",
                                        fontSize: "11px",
                                        fontWeight: "600",
                                        borderRadius: "12px",
                                        display: "inline-flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      ✓ Verified
                                    </span>
                                  )}
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    )}

                  {/* Date of Birth Field */}
                  {(ocrResponse?.dob || GetData?.dob || Digilockerdata?.dob) && (
                    <div style={{ border: "1px solid #E5E7EB", borderRadius: "8px", padding: "16px" }}>
                      <div>
                        <label
                          style={{
                            fontSize: "14px",
                            fontWeight: "500",
                            color: "#374151",
                            marginBottom: "8px",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          Date of Birth *
                          {formData.dob && Digilockerdata?.dob && formData.dob !== Digilockerdata.dob && (
                            <span style={{ marginLeft: "8px", padding: "2px 8px", backgroundColor: "#FEE2E2", color: "#B91C1C", fontSize: "11px", fontWeight: "600", borderRadius: "12px" }}>
                              Needs correction
                            </span>
                          )}
                        </label>

                        {(ocrResponse?.dob || GetData?.dob) && Digilockerdata?.dob && (ocrResponse?.dob || GetData?.dob) !== Digilockerdata.dob && (
                          <>
                            <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "4px" }}>Current (from OCR):</div>
                            <div style={{ display: "flex", alignItems: "center", padding: "8px 12px", backgroundColor: "#FEF2F2", border: "1px dashed #EF4444", borderRadius: "6px", marginBottom: "12px" }}>
                              <span style={{ color: "#B91C1C", fontSize: "14px", textDecoration: "line-through" }}>{ocrResponse?.dob || GetData?.dob}</span>
                            </div>
                          </>
                        )}

                        {Digilockerdata?.dob && (ocrResponse?.dob || GetData?.dob) !== Digilockerdata.dob && (
                          <>
                            <div style={{ marginBottom: "8px" }}>
                              <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "4px" }}>Correct to:</div>
                              <input type="text" name="dob" value={formData.dob || ocrResponse?.dob || GetData?.dob || ""} onChange={handleChange} style={{ width: "100%", padding: "8px 12px", border: "1px solid #93C5FD", borderRadius: "6px", fontSize: "14px", outline: "none" }} onFocus={(e) => (e.target.style.borderColor = "#3B82F6")} onBlur={(e) => (e.target.style.borderColor = "#93C5FD")} placeholder="Enter correct Date of Birth" />
                            </div>
                            <div>
                              <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "4px" }}>Suggested (from Verified Data):</div>
                              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 12px", backgroundColor: "#F0FDF4", border: "1px solid #86EFAC", borderRadius: "6px" }}>
                                <span style={{ color: "#15803D", fontSize: "14px", fontWeight: "500" }}>{Digilockerdata.dob}</span>
                                <button onClick={() => handleChange({ target: { name: "dob", value: Digilockerdata.dob } })} style={{ padding: "4px 12px", backgroundColor: "#16A34A", color: "white", fontSize: "12px", fontWeight: "500", border: "none", borderRadius: "4px", cursor: "pointer" }} onMouseEnter={(e) => (e.target.style.backgroundColor = "#15803D")} onMouseLeave={(e) => (e.target.style.backgroundColor = "#16A34A")}>Use This</button>
                              </div>
                            </div>
                          </>
                        )}

                        {Digilockerdata?.dob && (ocrResponse?.dob || GetData?.dob) === Digilockerdata.dob && (
                          <div style={{ display: "flex", alignItems: "center", padding: "8px 12px", backgroundColor: "#F0FDF4", border: "1px solid #86EFAC", borderRadius: "6px" }}>
                            <span style={{ color: "#15803D", fontSize: "14px", fontWeight: "500" }}>✓ Verified: {Digilockerdata.dob}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Father's Name Field */}
                  {(ocrResponse?.father_name || ocrResponse?.co || GetData?.co || Digilockerdata?.fatherName) && (
                    <div style={{ border: "1px solid #E5E7EB", borderRadius: "8px", padding: "16px" }}>
                      <div>
                        <label style={{ fontSize: "14px", fontWeight: "500", color: "#374151", marginBottom: "8px", display: "flex", alignItems: "center" }}>
                          Father's Name *
                          {formData.fatherName && Digilockerdata?.fatherName && formData.fatherName !== Digilockerdata.fatherName && (
                            <span style={{ marginLeft: "8px", padding: "2px 8px", backgroundColor: "#FEE2E2", color: "#B91C1C", fontSize: "11px", fontWeight: "600", borderRadius: "12px" }}>Needs correction</span>
                          )}
                        </label>

                        {(ocrResponse?.father_name || ocrResponse?.co || GetData?.co) && Digilockerdata?.fatherName && (ocrResponse?.father_name || ocrResponse?.co || GetData?.co) !== Digilockerdata.fatherName && (
                          <>
                            <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "4px" }}>Current (from OCR):</div>
                            <div style={{ display: "flex", alignItems: "center", padding: "8px 12px", backgroundColor: "#FEF2F2", border: "1px dashed #EF4444", borderRadius: "6px", marginBottom: "12px" }}>
                              <span style={{ color: "#B91C1C", fontSize: "14px", textDecoration: "line-through" }}>{ocrResponse?.father_name || ocrResponse?.co || GetData?.co}</span>
                            </div>
                          </>
                        )}

                        {Digilockerdata?.fatherName && (ocrResponse?.father_name || ocrResponse?.co || GetData?.co) !== Digilockerdata.fatherName && (
                          <>
                            <div style={{ marginBottom: "8px" }}>
                              <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "4px" }}>Correct to:</div>
                              <input type="text" name="fatherName" value={formData.fatherName || ocrResponse?.father_name || ocrResponse?.co || GetData?.co || ""} onChange={handleChange} style={{ width: "100%", padding: "8px 12px", border: "1px solid #93C5FD", borderRadius: "6px", fontSize: "14px", outline: "none" }} onFocus={(e) => (e.target.style.borderColor = "#3B82F6")} onBlur={(e) => (e.target.style.borderColor = "#93C5FD")} placeholder="Enter correct Father's Name" />
                            </div>
                            <div>
                              <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "4px" }}>Suggested (from Verified Data):</div>
                              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 12px", backgroundColor: "#F0FDF4", border: "1px solid #86EFAC", borderRadius: "6px" }}>
                                <span style={{ color: "#15803D", fontSize: "14px", fontWeight: "500" }}>{Digilockerdata.fatherName}</span>
                                <button onClick={() => handleChange({ target: { name: "fatherName", value: Digilockerdata.fatherName } })} style={{ padding: "4px 12px", backgroundColor: "#16A34A", color: "white", fontSize: "12px", fontWeight: "500", border: "none", borderRadius: "4px", cursor: "pointer" }} onMouseEnter={(e) => (e.target.style.backgroundColor = "#15803D")} onMouseLeave={(e) => (e.target.style.backgroundColor = "#16A34A")}>Use This</button>
                              </div>
                            </div>
                          </>
                        )}

                        {Digilockerdata?.fatherName && (ocrResponse?.father_name || ocrResponse?.co || GetData?.co) === Digilockerdata.fatherName && (
                          <div style={{ display: "flex", alignItems: "center", padding: "8px 12px", backgroundColor: "#F0FDF4", border: "1px solid #86EFAC", borderRadius: "6px" }}>
                            <span style={{ color: "#15803D", fontSize: "14px", fontWeight: "500" }}>✓ Verified: {Digilockerdata.fatherName}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Gender Field */}
                  {(ocrResponse?.gender || GetData?.gender || Digilockerdata?.gender) && (
                    <div style={{ border: "1px solid #E5E7EB", borderRadius: "8px", padding: "16px" }}>
                      <div>
                        <label style={{ fontSize: "14px", fontWeight: "500", color: "#374151", marginBottom: "8px", display: "flex", alignItems: "center" }}>
                          Gender *
                          {formData.gender && Digilockerdata?.gender && formData.gender !== Digilockerdata.gender && (
                            <span style={{ marginLeft: "8px", padding: "2px 8px", backgroundColor: "#FEE2E2", color: "#B91C1C", fontSize: "11px", fontWeight: "600", borderRadius: "12px" }}>Needs correction</span>
                          )}
                        </label>

                        {(ocrResponse?.gender || GetData?.gender) && Digilockerdata?.gender && formatGender(ocrResponse?.gender || GetData?.gender) !== Digilockerdata.gender && (
                          <>
                            <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "4px" }}>Current (from OCR):</div>
                            <div style={{ display: "flex", alignItems: "center", padding: "8px 12px", backgroundColor: "#FEF2F2", border: "1px dashed #EF4444", borderRadius: "6px", marginBottom: "12px" }}>
                              <span style={{ color: "#B91C1C", fontSize: "14px", textDecoration: "line-through" }}>{formatGender(ocrResponse?.gender || GetData?.gender)}</span>
                            </div>
                          </>
                        )}

                        {Digilockerdata?.gender && formatGender(ocrResponse?.gender || GetData?.gender) !== Digilockerdata.gender && (
                          <>
                            <div style={{ marginBottom: "8px" }}>
                              <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "4px" }}>Correct to:</div>
                              <input type="text" name="gender" value={formData.gender || formatGender(ocrResponse?.gender || GetData?.gender) || ""} onChange={handleChange} style={{ width: "100%", padding: "8px 12px", border: "1px solid #93C5FD", borderRadius: "6px", fontSize: "14px", outline: "none" }} onFocus={(e) => (e.target.style.borderColor = "#3B82F6")} onBlur={(e) => (e.target.style.borderColor = "#93C5FD")} placeholder="Enter correct Gender" />
                            </div>
                            <div>
                              <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "4px" }}>Suggested (from Verified Data):</div>
                              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 12px", backgroundColor: "#F0FDF4", border: "1px solid #86EFAC", borderRadius: "6px" }}>
                                <span style={{ color: "#15803D", fontSize: "14px", fontWeight: "500" }}>{Digilockerdata.gender}</span>
                                <button onClick={() => handleChange({ target: { name: "gender", value: Digilockerdata.gender } })} style={{ padding: "4px 12px", backgroundColor: "#16A34A", color: "white", fontSize: "12px", fontWeight: "500", border: "none", borderRadius: "4px", cursor: "pointer" }} onMouseEnter={(e) => (e.target.style.backgroundColor = "#15803D")} onMouseLeave={(e) => (e.target.style.backgroundColor = "#16A34A")}>Use This</button>
                              </div>
                            </div>
                          </>
                        )}

                        {Digilockerdata?.gender && formatGender(ocrResponse?.gender || GetData?.gender) === Digilockerdata.gender && (
                          <div style={{ display: "flex", alignItems: "center", padding: "8px 12px", backgroundColor: "#F0FDF4", border: "1px solid #86EFAC", borderRadius: "6px" }}>
                            <span style={{ color: "#15803D", fontSize: "14px", fontWeight: "500" }}>✓ Verified: {Digilockerdata.gender}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* House No Field */}
                  {(ocrResponse?.house || GetData?.house || Digilockerdata?.houseno) && (
                    <div style={{ border: "1px solid #E5E7EB", borderRadius: "8px", padding: "16px" }}>
                      <div>
                        <label style={{ fontSize: "14px", fontWeight: "500", color: "#374151", marginBottom: "8px", display: "flex", alignItems: "center" }}>
                          House No *
                          {formData.houseNo && Digilockerdata?.houseno && formData.houseNo !== Digilockerdata.houseno && (
                            <span style={{ marginLeft: "8px", padding: "2px 8px", backgroundColor: "#FEE2E2", color: "#B91C1C", fontSize: "11px", fontWeight: "600", borderRadius: "12px" }}>Needs correction</span>
                          )}
                        </label>

                        {(ocrResponse?.house || GetData?.house) && Digilockerdata?.houseno && (ocrResponse?.house || GetData?.house) !== Digilockerdata.houseno && (
                          <>
                            <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "4px" }}>Current (from OCR):</div>
                            <div style={{ display: "flex", alignItems: "center", padding: "8px 12px", backgroundColor: "#FEF2F2", border: "1px dashed #EF4444", borderRadius: "6px", marginBottom: "12px" }}>
                              <span style={{ color: "#B91C1C", fontSize: "14px", textDecoration: "line-through" }}>{ocrResponse?.house || GetData?.house || "NA"}</span>
                            </div>
                          </>
                        )}

                        {Digilockerdata?.houseno && (ocrResponse?.house || GetData?.house) !== Digilockerdata.houseno && (
                          <>
                            <div style={{ marginBottom: "8px" }}>
                              <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "4px" }}>Correct to:</div>
                              <input type="text" name="houseNo" value={formData.houseNo || ocrResponse?.house || GetData?.house || ""} onChange={handleChange} style={{ width: "100%", padding: "8px 12px", border: "1px solid #93C5FD", borderRadius: "6px", fontSize: "14px", outline: "none" }} onFocus={(e) => (e.target.style.borderColor = "#3B82F6")} onBlur={(e) => (e.target.style.borderColor = "#93C5FD")} placeholder="Enter correct House No" />
                            </div>
                            <div>
                              <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "4px" }}>Suggested (from Verified Data):</div>
                              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 12px", backgroundColor: "#F0FDF4", border: "1px solid #86EFAC", borderRadius: "6px" }}>
                                <span style={{ color: "#15803D", fontSize: "14px", fontWeight: "500" }}>{Digilockerdata.houseno}</span>
                                <button onClick={() => handleChange({ target: { name: "houseNo", value: Digilockerdata.houseno } })} style={{ padding: "4px 12px", backgroundColor: "#16A34A", color: "white", fontSize: "12px", fontWeight: "500", border: "none", borderRadius: "4px", cursor: "pointer" }} onMouseEnter={(e) => (e.target.style.backgroundColor = "#15803D")} onMouseLeave={(e) => (e.target.style.backgroundColor = "#16A34A")}>Use This</button>
                              </div>
                            </div>
                          </>
                        )}

                        {Digilockerdata?.houseno && (ocrResponse?.house || GetData?.house) === Digilockerdata.houseno && (
                          <div style={{ display: "flex", alignItems: "center", padding: "8px 12px", backgroundColor: "#F0FDF4", border: "1px solid #86EFAC", borderRadius: "6px" }}>
                            <span style={{ color: "#15803D", fontSize: "14px", fontWeight: "500" }}>✓ Verified: {Digilockerdata.houseno}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Street Field */}
                  {(ocrResponse?.street || GetData?.street || Digilockerdata?.street) && (
                    <div style={{ border: "1px solid #E5E7EB", borderRadius: "8px", padding: "16px" }}>
                      <div>
                        <label style={{ fontSize: "14px", fontWeight: "500", color: "#374151", marginBottom: "8px", display: "flex", alignItems: "center" }}>
                          Street *
                          {formData.street && Digilockerdata?.street && formData.street !== Digilockerdata.street && (
                            <span style={{ marginLeft: "8px", padding: "2px 8px", backgroundColor: "#FEE2E2", color: "#B91C1C", fontSize: "11px", fontWeight: "600", borderRadius: "12px" }}>Needs correction</span>
                          )}
                        </label>

                        {(ocrResponse?.street || GetData?.street) && Digilockerdata?.street && (ocrResponse?.street || GetData?.street) !== Digilockerdata.street && (
                          <>
                            <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "4px" }}>Current (from OCR):</div>
                            <div style={{ display: "flex", alignItems: "center", padding: "8px 12px", backgroundColor: "#FEF2F2", border: "1px dashed #EF4444", borderRadius: "6px", marginBottom: "12px" }}>
                              <span style={{ color: "#B91C1C", fontSize: "14px", textDecoration: "line-through" }}>{ocrResponse?.street || GetData?.street || "NA"}</span>
                            </div>
                          </>
                        )}

                        {Digilockerdata?.street && (ocrResponse?.street || GetData?.street) !== Digilockerdata.street && (
                          <>
                            <div style={{ marginBottom: "8px" }}>
                              <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "4px" }}>Correct to:</div>
                              <input type="text" name="street" value={formData.street || ocrResponse?.street || GetData?.street || ""} onChange={handleChange} style={{ width: "100%", padding: "8px 12px", border: "1px solid #93C5FD", borderRadius: "6px", fontSize: "14px", outline: "none" }} onFocus={(e) => (e.target.style.borderColor = "#3B82F6")} onBlur={(e) => (e.target.style.borderColor = "#93C5FD")} placeholder="Enter correct Street" />
                            </div>
                            <div>
                              <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "4px" }}>Suggested (from Verified Data):</div>
                              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 12px", backgroundColor: "#F0FDF4", border: "1px solid #86EFAC", borderRadius: "6px" }}>
                                <span style={{ color: "#15803D", fontSize: "14px", fontWeight: "500" }}>{Digilockerdata.street}</span>
                                <button onClick={() => handleChange({ target: { name: "street", value: Digilockerdata.street } })} style={{ padding: "4px 12px", backgroundColor: "#16A34A", color: "white", fontSize: "12px", fontWeight: "500", border: "none", borderRadius: "4px", cursor: "pointer" }} onMouseEnter={(e) => (e.target.style.backgroundColor = "#15803D")} onMouseLeave={(e) => (e.target.style.backgroundColor = "#16A34A")}>Use This</button>
                              </div>
                            </div>
                          </>
                        )}

                        {Digilockerdata?.street && (ocrResponse?.street || GetData?.street) === Digilockerdata.street && (
                          <div style={{ display: "flex", alignItems: "center", padding: "8px 12px", backgroundColor: "#F0FDF4", border: "1px solid #86EFAC", borderRadius: "6px" }}>
                            <span style={{ color: "#15803D", fontSize: "14px", fontWeight: "500" }}>✓ Verified: {Digilockerdata.street}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Locality/Village Field */}
                  {(ocrResponse?.locality || ocrResponse?.vtc || GetData?.locality || GetData?.vtc || Digilockerdata?.village) && (
                    <div style={{ border: "1px solid #E5E7EB", borderRadius: "8px", padding: "16px" }}>
                      <div>
                        <label style={{ fontSize: "14px", fontWeight: "500", color: "#374151", marginBottom: "8px", display: "flex", alignItems: "center" }}>
                          Locality/Village/Town *
                          {formData.village && Digilockerdata?.village && formData.village !== Digilockerdata.village && (
                            <span style={{ marginLeft: "8px", padding: "2px 8px", backgroundColor: "#FEE2E2", color: "#B91C1C", fontSize: "11px", fontWeight: "600", borderRadius: "12px" }}>Needs correction</span>
                          )}
                        </label>

                        {(ocrResponse?.locality || ocrResponse?.vtc || GetData?.locality || GetData?.vtc) && Digilockerdata?.village && (ocrResponse?.locality || ocrResponse?.vtc || GetData?.locality || GetData?.vtc) !== Digilockerdata.village && (
                          <>
                            <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "4px" }}>Current (from OCR):</div>
                            <div style={{ display: "flex", alignItems: "center", padding: "8px 12px", backgroundColor: "#FEF2F2", border: "1px dashed #EF4444", borderRadius: "6px", marginBottom: "12px" }}>
                              <span style={{ color: "#B91C1C", fontSize: "14px", textDecoration: "line-through" }}>{ocrResponse?.locality || ocrResponse?.vtc || GetData?.locality || GetData?.vtc || "NA"}</span>
                            </div>
                          </>
                        )}

                        {Digilockerdata?.village && (ocrResponse?.locality || ocrResponse?.vtc || GetData?.locality || GetData?.vtc) !== Digilockerdata.village && (
                          <>
                            <div style={{ marginBottom: "8px" }}>
                              <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "4px" }}>Correct to:</div>
                              <input type="text" name="village" value={formData.village || ocrResponse?.locality || ocrResponse?.vtc || GetData?.locality || GetData?.vtc || ""} onChange={handleChange} style={{ width: "100%", padding: "8px 12px", border: "1px solid #93C5FD", borderRadius: "6px", fontSize: "14px", outline: "none" }} onFocus={(e) => (e.target.style.borderColor = "#3B82F6")} onBlur={(e) => (e.target.style.borderColor = "#93C5FD")} placeholder="Enter correct Locality" />
                            </div>
                            <div>
                              <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "4px" }}>Suggested (from Verified Data):</div>
                              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 12px", backgroundColor: "#F0FDF4", border: "1px solid #86EFAC", borderRadius: "6px" }}>
                                <span style={{ color: "#15803D", fontSize: "14px", fontWeight: "500" }}>{Digilockerdata.village}</span>
                                <button onClick={() => handleChange({ target: { name: "village", value: Digilockerdata.village } })} style={{ padding: "4px 12px", backgroundColor: "#16A34A", color: "white", fontSize: "12px", fontWeight: "500", border: "none", borderRadius: "4px", cursor: "pointer" }} onMouseEnter={(e) => (e.target.style.backgroundColor = "#15803D")} onMouseLeave={(e) => (e.target.style.backgroundColor = "#16A34A")}>Use This</button>
                              </div>
                            </div>
                          </>
                        )}

                        {Digilockerdata?.village && (ocrResponse?.locality || ocrResponse?.vtc || GetData?.locality || GetData?.vtc) === Digilockerdata.village && (
                          <div style={{ display: "flex", alignItems: "center", padding: "8px 12px", backgroundColor: "#F0FDF4", border: "1px solid #86EFAC", borderRadius: "6px" }}>
                            <span style={{ color: "#15803D", fontSize: "14px", fontWeight: "500" }}>✓ Verified: {Digilockerdata.village}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* City Field */}
                  {(ocrResponse?.city || GetData?.city || Digilockerdata?.city) && (
                    <div style={{ border: "1px solid #E5E7EB", borderRadius: "8px", padding: "16px" }}>
                      <div>
                        <label style={{ fontSize: "14px", fontWeight: "500", color: "#374151", marginBottom: "8px", display: "flex", alignItems: "center" }}>
                          City *
                          {formData.city && Digilockerdata?.city && formData.city !== Digilockerdata.city && (
                            <span style={{ marginLeft: "8px", padding: "2px 8px", backgroundColor: "#FEE2E2", color: "#B91C1C", fontSize: "11px", fontWeight: "600", borderRadius: "12px" }}>Needs correction</span>
                          )}
                        </label>

                        {(ocrResponse?.city || GetData?.city) && Digilockerdata?.city && (ocrResponse?.city || GetData?.city) !== Digilockerdata.city && (
                          <>
                            <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "4px" }}>Current (from OCR):</div>
                            <div style={{ display: "flex", alignItems: "center", padding: "8px 12px", backgroundColor: "#FEF2F2", border: "1px dashed #EF4444", borderRadius: "6px", marginBottom: "12px" }}>
                              <span style={{ color: "#B91C1C", fontSize: "14px", textDecoration: "line-through" }}>{ocrResponse?.city || GetData?.city || "NA"}</span>
                            </div>
                          </>
                        )}

                        {Digilockerdata?.city && (ocrResponse?.city || GetData?.city) !== Digilockerdata.city && (
                          <>
                            <div style={{ marginBottom: "8px" }}>
                              <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "4px" }}>Correct to:</div>
                              <input type="text" name="city" value={formData.city || ocrResponse?.city || GetData?.city || ""} onChange={handleChange} style={{ width: "100%", padding: "8px 12px", border: "1px solid #93C5FD", borderRadius: "6px", fontSize: "14px", outline: "none" }} onFocus={(e) => (e.target.style.borderColor = "#3B82F6")} onBlur={(e) => (e.target.style.borderColor = "#93C5FD")} placeholder="Enter correct City" />
                            </div>
                            <div>
                              <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "4px" }}>Suggested (from Verified Data):</div>
                              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 12px", backgroundColor: "#F0FDF4", border: "1px solid #86EFAC", borderRadius: "6px" }}>
                                <span style={{ color: "#15803D", fontSize: "14px", fontWeight: "500" }}>{Digilockerdata.city}</span>
                                <button onClick={() => handleChange({ target: { name: "city", value: Digilockerdata.city } })} style={{ padding: "4px 12px", backgroundColor: "#16A34A", color: "white", fontSize: "12px", fontWeight: "500", border: "none", borderRadius: "4px", cursor: "pointer" }} onMouseEnter={(e) => (e.target.style.backgroundColor = "#15803D")} onMouseLeave={(e) => (e.target.style.backgroundColor = "#16A34A")}>Use This</button>
                              </div>
                            </div>
                          </>
                        )}

                        {Digilockerdata?.city && (ocrResponse?.city || GetData?.city) === Digilockerdata.city && (
                          <div style={{ display: "flex", alignItems: "center", padding: "8px 12px", backgroundColor: "#F0FDF4", border: "1px solid #86EFAC", borderRadius: "6px" }}>
                            <span style={{ color: "#15803D", fontSize: "14px", fontWeight: "500" }}>✓ Verified: {Digilockerdata.city}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* District Field */}
                  {(ocrResponse?.district || GetData?.district || Digilockerdata?.district) && (
                    <div style={{ border: "1px solid #E5E7EB", borderRadius: "8px", padding: "16px" }}>
                      <div>
                        <label style={{ fontSize: "14px", fontWeight: "500", color: "#374151", marginBottom: "8px", display: "flex", alignItems: "center" }}>
                          District *
                          {formData.district && Digilockerdata?.district && formData.district !== Digilockerdata.district && (
                            <span style={{ marginLeft: "8px", padding: "2px 8px", backgroundColor: "#FEE2E2", color: "#B91C1C", fontSize: "11px", fontWeight: "600", borderRadius: "12px" }}>Needs correction</span>
                          )}
                        </label>

                        {(ocrResponse?.district || GetData?.district) && Digilockerdata?.district && (ocrResponse?.district || GetData?.district) !== Digilockerdata.district && (
                          <>
                            <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "4px" }}>Current (from OCR):</div>
                            <div style={{ display: "flex", alignItems: "center", padding: "8px 12px", backgroundColor: "#FEF2F2", border: "1px dashed #EF4444", borderRadius: "6px", marginBottom: "12px" }}>
                              <span style={{ color: "#B91C1C", fontSize: "14px", textDecoration: "line-through" }}>{ocrResponse?.district || GetData?.district || "NA"}</span>
                            </div>
                          </>
                        )}

                        {Digilockerdata?.district && (ocrResponse?.district || GetData?.district) !== Digilockerdata.district && (
                          <>
                            <div style={{ marginBottom: "8px" }}>
                              <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "4px" }}>Correct to:</div>
                              <input type="text" name="district" value={formData.district || ocrResponse?.district || GetData?.district || ""} onChange={handleChange} style={{ width: "100%", padding: "8px 12px", border: "1px solid #93C5FD", borderRadius: "6px", fontSize: "14px", outline: "none" }} onFocus={(e) => (e.target.style.borderColor = "#3B82F6")} onBlur={(e) => (e.target.style.borderColor = "#93C5FD")} placeholder="Enter correct District" />
                            </div>
                            <div>
                              <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "4px" }}>Suggested (from Verified Data):</div>
                              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 12px", backgroundColor: "#F0FDF4", border: "1px solid #86EFAC", borderRadius: "6px" }}>
                                <span style={{ color: "#15803D", fontSize: "14px", fontWeight: "500" }}>{Digilockerdata.district}</span>
                                <button onClick={() => handleChange({ target: { name: "district", value: Digilockerdata.district } })} style={{ padding: "4px 12px", backgroundColor: "#16A34A", color: "white", fontSize: "12px", fontWeight: "500", border: "none", borderRadius: "4px", cursor: "pointer" }} onMouseEnter={(e) => (e.target.style.backgroundColor = "#15803D")} onMouseLeave={(e) => (e.target.style.backgroundColor = "#16A34A")}>Use This</button>
                              </div>
                            </div>
                          </>
                        )}

                        {Digilockerdata?.district && (ocrResponse?.district || GetData?.district) === Digilockerdata.district && (
                          <div style={{ display: "flex", alignItems: "center", padding: "8px 12px", backgroundColor: "#F0FDF4", border: "1px solid #86EFAC", borderRadius: "6px" }}>
                            <span style={{ color: "#15803D", fontSize: "14px", fontWeight: "500" }}>✓ Verified: {Digilockerdata.district}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* State Field */}
                  {(ocrResponse?.state || GetData?.state || Digilockerdata?.State) && (
                    <div style={{ border: "1px solid #E5E7EB", borderRadius: "8px", padding: "16px" }}>
                      <div>
                        <label style={{ fontSize: "14px", fontWeight: "500", color: "#374151", marginBottom: "8px", display: "flex", alignItems: "center" }}>
                          State *
                          {formData.state && Digilockerdata?.State && formData.state !== Digilockerdata.State && (
                            <span style={{ marginLeft: "8px", padding: "2px 8px", backgroundColor: "#FEE2E2", color: "#B91C1C", fontSize: "11px", fontWeight: "600", borderRadius: "12px" }}>Needs correction</span>
                          )}
                        </label>

                        {(ocrResponse?.state || GetData?.state) && Digilockerdata?.State && (ocrResponse?.state || GetData?.state) !== Digilockerdata.State && (
                          <>
                            <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "4px" }}>Current (from OCR):</div>
                            <div style={{ display: "flex", alignItems: "center", padding: "8px 12px", backgroundColor: "#FEF2F2", border: "1px dashed #EF4444", borderRadius: "6px", marginBottom: "12px" }}>
                              <span style={{ color: "#B91C1C", fontSize: "14px", textDecoration: "line-through" }}>{ocrResponse?.state || GetData?.state || "NA"}</span>
                            </div>
                          </>
                        )}

                        {Digilockerdata?.State && (ocrResponse?.state || GetData?.state) !== Digilockerdata.State && (
                          <>
                            <div style={{ marginBottom: "8px" }}>
                              <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "4px" }}>Correct to:</div>
                              <input type="text" name="state" value={formData.state || ocrResponse?.state || GetData?.state || ""} onChange={handleChange} style={{ width: "100%", padding: "8px 12px", border: "1px solid #93C5FD", borderRadius: "6px", fontSize: "14px", outline: "none" }} onFocus={(e) => (e.target.style.borderColor = "#3B82F6")} onBlur={(e) => (e.target.style.borderColor = "#93C5FD")} placeholder="Enter correct State" />
                            </div>
                            <div>
                              <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "4px" }}>Suggested (from Verified Data):</div>
                              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 12px", backgroundColor: "#F0FDF4", border: "1px solid #86EFAC", borderRadius: "6px" }}>
                                <span style={{ color: "#15803D", fontSize: "14px", fontWeight: "500" }}>{Digilockerdata.State}</span>
                                <button onClick={() => handleChange({ target: { name: "state", value: Digilockerdata.State } })} style={{ padding: "4px 12px", backgroundColor: "#16A34A", color: "white", fontSize: "12px", fontWeight: "500", border: "none", borderRadius: "4px", cursor: "pointer" }} onMouseEnter={(e) => (e.target.style.backgroundColor = "#15803D")} onMouseLeave={(e) => (e.target.style.backgroundColor = "#16A34A")}>Use This</button>
                              </div>
                            </div>
                          </>
                        )}

                        {Digilockerdata?.State && (ocrResponse?.state || GetData?.state) === Digilockerdata.State && (
                          <div style={{ display: "flex", alignItems: "center", padding: "8px 12px", backgroundColor: "#F0FDF4", border: "1px solid #86EFAC", borderRadius: "6px" }}>
                            <span style={{ color: "#15803D", fontSize: "14px", fontWeight: "500" }}>✓ Verified: {Digilockerdata.State}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {/* Postal Code Field */}
                  {(ocrResponse?.postal_code || GetData?.postal_code || Digilockerdata?.postalCode) && (
                    <div style={{ border: "1px solid #E5E7EB", borderRadius: "8px", padding: "16px" }}>
                      <div>
                        <label style={{ fontSize: "14px", fontWeight: "500", color: "#374151", marginBottom: "8px", display: "flex", alignItems: "center" }}>
                          Postal Code *
                          {formData.postalCode && Digilockerdata?.postalCode && formData.postalCode !== Digilockerdata.postalCode && (
                            <span style={{ marginLeft: "8px", padding: "2px 8px", backgroundColor: "#FEE2E2", color: "#B91C1C", fontSize: "11px", fontWeight: "600", borderRadius: "12px" }}>Needs correction</span>
                          )}
                        </label>

                        {(ocrResponse?.postal_code || GetData?.postal_code) && Digilockerdata?.postalCode && (ocrResponse?.postal_code || GetData?.postal_code) !== Digilockerdata.postalCode && (
                          <>
                            <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "4px" }}>Current (from OCR):</div>
                            <div style={{ display: "flex", alignItems: "center", padding: "8px 12px", backgroundColor: "#FEF2F2", border: "1px dashed #EF4444", borderRadius: "6px", marginBottom: "12px" }}>
                              <span style={{ color: "#B91C1C", fontSize: "14px", textDecoration: "line-through" }}>{ocrResponse?.postal_code || GetData?.postal_code || "NA"}</span>
                            </div>
                          </>
                        )}

                        {Digilockerdata?.postalCode && (ocrResponse?.postal_code || GetData?.postal_code) !== Digilockerdata.postalCode && (
                          <>
                            <div style={{ marginBottom: "8px" }}>
                              <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "4px" }}>Correct to:</div>
                              <input type="text" name="postalCode" value={formData.postalCode || ocrResponse?.postal_code || GetData?.postal_code || ""} onChange={handleChange} style={{ width: "100%", padding: "8px 12px", border: "1px solid #93C5FD", borderRadius: "6px", fontSize: "14px", outline: "none" }} onFocus={(e) => (e.target.style.borderColor = "#3B82F6")} onBlur={(e) => (e.target.style.borderColor = "#93C5FD")} placeholder="Enter correct Postal Code" />
                            </div>
                            <div>
                              <div style={{ fontSize: "12px", color: "#6B7280", marginBottom: "4px" }}>Suggested (from Verified Data):</div>
                              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 12px", backgroundColor: "#F0FDF4", border: "1px solid #86EFAC", borderRadius: "6px" }}>
                                <span style={{ color: "#15803D", fontSize: "14px", fontWeight: "500" }}>{Digilockerdata.postalCode}</span>
                                <button onClick={() => handleChange({ target: { name: "postalCode", value: Digilockerdata.postalCode } })} style={{ padding: "4px 12px", backgroundColor: "#16A34A", color: "white", fontSize: "12px", fontWeight: "500", border: "none", borderRadius: "4px", cursor: "pointer" }} onMouseEnter={(e) => (e.target.style.backgroundColor = "#15803D")} onMouseLeave={(e) => (e.target.style.backgroundColor = "#16A34A")}>Use This</button>
                              </div>
                            </div>
                          </>
                        )}

                        {Digilockerdata?.postalCode && (ocrResponse?.postal_code || GetData?.postal_code) === Digilockerdata.postalCode && (
                          <div style={{ display: "flex", alignItems: "center", padding: "8px 12px", backgroundColor: "#F0FDF4", border: "1px solid #86EFAC", borderRadius: "6px" }}>
                            <span style={{ color: "#15803D", fontSize: "14px", fontWeight: "500" }}>✓ Verified: {Digilockerdata.postalCode}</span>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>

                {/* No Data Message */}
                {!hasAnyData() && (
                  <div style={{ textAlign: "center", padding: "32px 0" }}>
                    <div style={{ fontSize: "48px", color: "#9CA3AF", marginBottom: "16px" }}>
                      📄
                    </div>
                    <h3
                      style={{
                        fontSize: "18px",
                        fontWeight: "600",
                        color: "#111827",
                        marginBottom: "8px",
                      }}
                    >
                      No Data Available
                    </h3>
                    <p style={{ fontSize: "14px", color: "#6B7280", margin: "0" }}>
                      No Aadhaar data found from OCR or Digilocker.
                    </p>
                  </div>
                )}

                {/* Footer */}
                {hasAnyData() && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      marginTop: "32px",
                      paddingTop: "24px",
                      borderTop: "1px solid #E5E7EB",
                    }}
                  >
                    <div style={{ fontSize: "14px", color: "#6B7280" }}>
                      {getMismatchCount() > 0 && (
                        <span style={{ color: "#DC2626", fontWeight: "500" }}>
                          Please correct the field(s) above
                        </span>
                      )}
                    </div>

                    <div style={{ display: "flex" }}>
                      <button
                        onClick={() => setClose(false)}
                        style={{ padding: "8px 24px", color: "#2563EB", fontWeight: "500", fontSize: "14px", background: "none", border: "none", cursor: "pointer", marginRight: "16px" }}
                        onMouseEnter={(e) => (e.target.style.color = "#1D4ED8")}
                        onMouseLeave={(e) => (e.target.style.color = "#2563EB")}
                      >
                        CANCEL
                      </button>

                      {GetData && Object.keys(GetData).length > 0 && GetData !== "Not verified Yet" ? (
                        <button
                          style={{ padding: "8px 24px", backgroundColor: "#16A34A", color: "white", fontWeight: "500", fontSize: "14px", borderRadius: "8px", border: "none", opacity: "0.7", cursor: "not-allowed" }}
                          disabled
                        >
                          VERIFIED
                        </button>
                      ) : (
                        <button
                          onClick={() => handleupdate()}
                          disabled={getMismatchCount() !== 0}
                          style={{
                            padding: "8px 24px",
                            backgroundColor: getMismatchCount() === 0 ? "#2563EB" : "#9CA3AF",
                            color: "white",
                            fontWeight: "500",
                            fontSize: "14px",
                            borderRadius: "8px",
                            border: "none",
                            cursor: getMismatchCount() === 0 ? "pointer" : "not-allowed",
                            transition: "background-color 0.2s",
                          }}
                          onMouseEnter={(e) => { if (getMismatchCount() === 0) e.target.style.backgroundColor = "#1D4ED8"; }}
                          onMouseLeave={(e) => { if (getMismatchCount() === 0) e.target.style.backgroundColor = "#2563EB"; }}
                        >
                          SAVE CORRECTIONS
                        </button>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </Modal>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyAadhar;